export const emptySupplier = {
  name: "",
  gst_number: "",
  address: "",
  contact_person: "",
  phone: "",
  email: "",
};

export const emptyItem = () => ({
  name: "",
  quantity: 1,
  unit_price: 0,
  gst_rate: 0,
});

export const today = () => new Date().toISOString().slice(0, 10);

export const inputClass = [
  "mt-1 w-full border border-[#E2DCD2] bg-white px-3 py-2 text-sm text-[#1E2A24]",
  "outline-none focus:border-[#2D5A47]",
].join(" ");

export const labelClass = [
  "text-xs font-semibold uppercase tracking-[0.14em]",
  "text-[#8C6D46]",
].join(" ");

export const purchaseTotals = (items) => items.reduce(
  (totals, item) => {
    const quantity = Number(item.quantity) || 0;
    const unitPrice = Number(item.unit_price) || 0;
    const gstRate = Number(item.gst_rate) || 0;
    const amount = quantity * unitPrice;
    const gstAmount = amount * gstRate / 100;
    return {
      amount: totals.amount + amount,
      gstAmount: totals.gstAmount + gstAmount,
      totalAmount: totals.totalAmount + amount + gstAmount,
    };
  },
  { amount: 0, gstAmount: 0, totalAmount: 0 },
);

export const formatBillDate = (value) => {
  if (!value) {
    return "—";
  }
  return new Intl.DateTimeFormat("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  }).format(new Date(`${value}T00:00:00`));
};